<template>
  <global-dialog-card
    v-model="model"
    hide-actions
    :title="`${$t('order_details')} ${localeDate(dailyMenu.date)}`"
    :max-width="700"
  >
    <div class="mt-4">
      <template v-for="shift in shiftsWithOrder">
        <shift-header :shift="shift"></shift-header>
        <div class="mb-4">
          <company-menu-food-order-card
            v-for="meal in shift.meals.filter((m) => m.order)"
            :key="meal.id"
            :meal="meal"
            :daily-menu="dailyMenu"
            :shift="shift.text"
            hide-details
            class="mb-4"
          ></company-menu-food-order-card>
        </div>
      </template>
    </div>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import CompanyMenuFoodOrderCard from "@/components/companyMenu/cards/CompanyMenuFoodOrderCard.vue";
import ShiftHeader from "../components/ShiftHeader.vue";

export default {
  name: "CompanyMenuFoodOrderDialog",
  mixins: [hasModel],
  props: {
    dailyMenu: {
      type: Object,
      required: true,
    },
  },
  components: {
    CompanyMenuFoodOrderCard,
    ShiftHeader,
  },
  computed: {
    shiftsWithOrder() {
      return this.dailyMenu.shifts.filter((shift) =>
        shift.meals.some((meal) => meal.order)
      );
    },
  },
};
</script>
